export const appRootTag = "body"

export const appBuildAssetsDir = "static"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"trustpilot-one-time-domain-verification-id","content":"eefed3e9-c4f0-44aa-96c9-7d2a821858ca"}],"link":[{"rel":"preconnect","href":"https://shop.ldrescdn.com"},{"rel":"preconnect","href":"https://api.ldshop.gg"},{"rel":"dns-prefetch","href":"https://shop.ldrescdn.com"},{"rel":"dns-prefetch","href":"https://res.ldplayer.net"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://bat.bing.com"},{"rel":"dns-prefetch","href":"https://cmp.setupcmp.com"},{"rel":"dns-prefetch","href":"https://api.ldshop.gg"},{"rel":"dns-prefetch","href":"https://widget.trustpilot.com"},{"rel":"dns-prefetch","href":"https://sg-sentry.changzhi.top"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appCdnURL = "https://cdn.mone.gg/prod"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false